faq.component('faq.faqModalComponent', {
    templateUrl: 'faq/faqModal/faqModal.html',
    controller: 'faq.faqModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

faq.controller('faq.faqModalController', ['$scope', 'coreLanguage', 'coreFb', '$filter', function($scope, $text, $fb, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    const formErrosDefault = {
        titulo:{},
        descricao:{}
    };

    $ctrl.close=()=>{
        $ctrl.config.show = false;
        $ctrl.formErrors = formErrosDefault;
    };

    $ctrl.onBlur = (field) => {
        $ctrl.formErrors[field] = {
            field: !$scope.formContato[field].$valid,
            hint: !$scope.formContato[field].$valid
        };
    };

    $ctrl.validateForm=()=>{
        if($scope.formContato.$valid){
            $ctrl.config.confirm();
        }else{
            Object.keys(formErrosDefault).forEach(key=>{ $ctrl.onBlur(key); });
        }
    };

    $scope.$watch('$modal.config.show', (newValue) => {
        if(newValue){ 
            $ctrl.formErrors = angular.copy(formErrosDefault);

            const hasProduto = $filter('filter')($ctrl.config.options, {id: $ctrl.config.dados.idProduto});
            $ctrl.selectedProduto = hasProduto[0] ?? null;
            
            const hasModulo = $filter('filter')($ctrl.selectedProduto.modulos, {id: $ctrl.config.dados.idModulo});
            $ctrl.selectedModulo = hasModulo.length ? hasModulo[0] : null;
        }
    });

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idUsuario;
    };

}]);